// MetadataFieldSubmenu
//
// Select a subfield from metadata group.

import { observer } from 'mobx-react-lite'

import { Menu, MenuItem } from '../components'

export const MetadataFieldSubmenu = observer(function MetadataFieldSubmenu({
    groupname,
    fieldnames,
    onSelectMetadataField,
}) {
    const selectMetadataField = fieldname => {
        onSelectMetadataField && onSelectMetadataField(groupname + '.' + fieldname)
    }

    const menuitems = Array.from(fieldnames.values()).map(fieldname => {
        return (
            <MenuItem
                key={groupname + '.' + fieldname}
                onClick={e => selectMetadataField(fieldname)}
            >
                {fieldname}
            </MenuItem>
        )
    })

    return <Menu>{menuitems}</Menu>
})
